import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const KnowledgeBase = lazy(() => import('../../container/knowledge_base/KnowledgeBase'));
const SingleView = lazy(() => import('../../container/knowledge_base/SingleView'));
// const EditKnowledgeInfo = lazy(() => import('../../container/knowledge_base/EditKnowledgeInfo'));

function KnowledgeBaseRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}`} component={KnowledgeBase} />
      <Route path={`${path}/single-view/:id`} component={SingleView} />
      {/* <Route path={`${path}/edit/:id`} component={EditKnowledgeInfo} /> */}
    </Switch>
  );
}

export default KnowledgeBaseRoutes;
